import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=7b4aebf8&scoped=true&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"
import style0 from "./Tab.vue?vue&type=style&index=0&id=7b4aebf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4aebf8",
  null
  
)

component.options.__file = "Tab.vue"
export default component.exports